import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// A byline, not a badge. The panel sits between the quick answer and the detail
// so a stranger arriving from a search engine or an AI assistant can see that a
// named person with relevant experience stands behind the answer — then scroll
// straight past it.
export const ReviewerPanel = ({ reviewer }) => {
  if (!reviewer?.name) return null;
  const first = String(reviewer.name).split(" ")[0];

  return (
    <aside
      className="mt-8 rounded-xl border border-slate-200 bg-white px-5 py-4"
      data-testid="answer-reviewer-panel"
    >
      <div className="flex items-start gap-4">
        {reviewer.photo && (
          <Link to={reviewer.url} className="shrink-0" tabIndex={-1} aria-hidden="true">
            <img
              src={reviewer.photo}
              alt=""
              width={56}
              height={56}
              className="w-14 h-14 rounded-md object-cover"
              data-testid="answer-reviewer-photo"
            />
          </Link>
        )}
        <div className="min-w-0">
          <p className="text-sm text-slate-500">
            Reviewed by{" "}
            <Link to={reviewer.url} className="font-bold text-navy hover:text-orange transition-colors" data-testid="answer-reviewer-link">
              {reviewer.name}
            </Link>
            {reviewer.role && <span className="text-slate-500">, {reviewer.role}</span>}
          </p>
          {(reviewer.markers || []).length > 0 && (
            <p className="text-xs text-slate-500 mt-1.5 leading-relaxed" data-testid="answer-reviewer-markers">
              {reviewer.markers.map((m, i) => (
                <span key={m}>
                  {i > 0 && <span className="text-slate-300 mx-1.5">·</span>}
                  {m}
                </span>
              ))}
            </p>
          )}
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2.5">
            {reviewer.reviewed_month && (
              <span className="text-xs text-slate-400" data-testid="answer-reviewer-date">
                Reviewed: {reviewer.reviewed_month}
              </span>
            )}
            <Link
              to={reviewer.url}
              className="inline-flex items-center gap-1 text-xs font-bold text-navy hover:text-orange transition-colors"
              data-testid="answer-reviewer-about"
            >
              About {first} <ArrowRight size={12} />
            </Link>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default ReviewerPanel;
